import React, { useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { requestPasswordReset } from "../../actions/auth";
import Modal from "../common/Modal/Modal";
import { useSubmitGuard } from "../common/Helpers";

export function ForgotPassword(props) {

    const [email, setEmail] = useState("");
    const [submitted, setSubmitted] = useState(false);
    const { isSubmitting, guardedSubmit } = useSubmitGuard();

    const onSubmit = guardedSubmit((e) => {
        e.preventDefault();
        return props.requestPasswordReset(email).then((didSucceed) => didSucceed && setSubmitted(true));
    });

    if (submitted) {
        return (
            <Modal slogan={true} className="forgot-password">
                <div className="text-center">
                    <p className="content1 heavy gap-below-m">Check your email</p>
                    <p className="content1 light-black multiline gap-below-l">If an account exists for {email}, we've sent a link to reset your password.</p>
                    <Link to="/login" id="login" className="link1">Back to Login</Link>
                </div>
            </Modal>
        );
    }

    return (
        <Modal slogan={true} className="forgot-password">
            {/* Modal renders the real slogan as a direct flex child of .modal (which centers it),
                but wraps props.children in a plain, non-flex "w100" div -- so the .slogan class's
                width:80% would just left-align here instead of centering. Overriding to 100% width
                lets text-align:center do the centering the same way the real slogan gets it. */}
            <p className="slogan g5-text gap-below-m" style={{width: "100%"}}>Enter the email address associated with your account and we'll send you a link to reset your password.</p>
            <form className="form" onSubmit={(e) => onSubmit(e)}>
                <div className="inputs-wrapper gap-below-s">
                    <div className="input-basic">
                        <input
                            type="email"
                            name="email"
                            onChange={(e) => setEmail(e.target.value)}
                            value={email}
                            id="email"
                            required
                        />
                        <label htmlFor="email">Email </label>
                    </div>
                </div>
                <div className="flex-row center">
                    <button style={{width: "100%"}} type="submit" id="send-reset-link" className="btn pri gap-below-s gap-above-s" disabled={isSubmitting}>
                        {isSubmitting ? "SENDING..." : "SEND RESET LINK"}
                    </button>
                </div>
            </form>
            <Link style={{width: "100%"}} id="back-to-login" className="btn sec gap-below-m" to="/login">BACK TO LOGIN</Link>
        </Modal>
    );
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps, { requestPasswordReset })(ForgotPassword);
